import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";
import * as utilities from "../actions/utilities";
import { SET_SERVER_TIME } from "../types";
import moment from "moment";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
function* watchTick() {
  yield takeEvery(SET_SERVER_TIME, tick);
}

// todo maybe ? or delete
function* tick() {
  while (true) {
    const getServerTime = (state) => state.utilities.serverTime;
    let now = yield select(getServerTime);
    yield call(delay, 1000);
    let tickOne = moment(now).add(1, "s");
    yield put(utilities.tickServerTime(moment(tickOne).toString()));
  }
}
export default function* utilitiesSaga() {
  yield all([fork(watchTick)]);
}
